var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasicplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FDDCAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5619 37.5592C33.3998 37.5588 33.2402 37.519 33.0969 37.4432L27.9999 34.7632L22.9029 37.4432C22.7379 37.5297 22.5519 37.5683 22.3661 37.5548C22.1803 37.5412 22.002 37.4761 21.8512 37.3666C21.7004 37.2571 21.5833 37.1077 21.5129 36.9352C21.4425 36.7627 21.4217 36.5739 21.4529 36.3902L22.4259 30.7142L18.3019 26.6942C18.1685 26.564 18.0741 26.399 18.0295 26.218C17.9849 26.0369 17.9918 25.847 18.0494 25.6697C18.1071 25.4924 18.2131 25.3347 18.3556 25.2144C18.4981 25.0942 18.6714 25.0162 18.8559 24.9892L24.5549 24.1612L27.1039 18.9972C27.1957 18.8411 27.3267 18.7116 27.484 18.6216C27.6412 18.5317 27.8192 18.4844 28.0004 18.4844C28.1815 18.4844 28.3596 18.5317 28.5168 18.6216C28.674 18.7116 28.8051 18.8411 28.8969 18.9972L31.4449 24.1612L37.1439 24.9892C37.3284 25.0162 37.5017 25.0942 37.6442 25.2144C37.7867 25.3347 37.8927 25.4924 37.9503 25.6697C38.008 25.847 38.0149 26.0369 37.9702 26.218C37.9256 26.399 37.8313 26.564 37.6979 26.6942L33.5739 30.7142L34.5479 36.3902C34.5725 36.5337 34.5655 36.6808 34.5273 36.8213C34.4892 36.9618 34.4208 37.0923 34.327 37.2036C34.2332 37.3149 34.1162 37.4044 33.9842 37.4658C33.8523 37.5273 33.7075 37.5591 33.5619 37.5592Z",
    fill: "#F99806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicplan);
export default __webpack_public_path__ + "static/media/basicplan.499bfd0aeeddd41b5ab193366177a8da.svg";
export { ForwardRef as ReactComponent };